"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.verifyCryptographicStrength = exports.cryptographicStrength = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
// import * as $wl from './index.js'

var regex = function regex() {
  var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 6;
  var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 16;
  return "{".concat(a !== null && a !== void 0 ? a : '', ",").concat(b !== null && b !== void 0 ? b : '', "}");
};
// eslint-disable-next-line no-eval
var regexA = function regexA(a, b) {
  return eval("/^((\\d".concat(regex(a, b), ")|([a-z]").concat(regex(a, b), ")|([A-Z]").concat(regex(a, b), "))$/"));
};
// eslint-disable-next-line no-eval
var regexB = function regexB(a, b) {
  return eval("/^(?![\\d]+$)(?![a-zA-Z]+$)(?![^\\da-zA-Z]+$).".concat(regex(a, b), "$/"));
};
// eslint-disable-next-line no-eval
var regexC = function regexC(a, b) {
  return eval("/^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).".concat(regex(a, b), "$/"));
};

/** 密码强度等级
 * @description: 输入密码，对密码进行处理判断密码强度
 * @param { String } pass 要校验的密码
 * @param { Number } minPass 最小位数
 * @param { Number } maxPass 最大位数
 * @return { Number } 返回密码强度等级
 */
var cryptographicStrength = exports.cryptographicStrength = function cryptographicStrength(pass) {
  var minPass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
  if (regexC(minPass).test(pass)) return 3;
  if (regexB(minPass).test(pass)) return 2;
  if (regexA(minPass).test(pass)) return 1;
};

/** 校验密码强度
 * @description: 输入密码，对密码进行处理判断密码强度
 * @param { String } pass 要校验的密码
 * @param { Number } minPass 最小位数
 * @param { Number } maxPass 最大位数
 * @return { Number } 返回密码强度评分
 */
var verifyCryptographicStrength = exports.verifyCryptographicStrength = function verifyCryptographicStrength(pass) {
  var minPass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
  var maxPass = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 16;
  // 符合条件长度  每一位权重
  var a = 50 / (maxPass - minPass);
  var score = (String(pass).length - minPass) * a;
  if (regexC(minPass).test(pass)) score += 50;else if (regexB(minPass).test(pass)) score += 30;else if (regexA(minPass).test(pass)) score += 10;
  if (score < 0) return 0;else if (score > 100) return 100;
  return score;
};